module.exports = __webpack_public_path__ + "img/logo.344b098f.png";